import { Builder } from '@builder.io/react'

import SecaoHero from './components/secoes/SecaoHero'
import SecaoPalco from './components/secoes/SecaoPalco'
import SecaoPalestrantes from './components/secoes/SecaoPalestrantes'
import SecaoPublico from './components/secoes/SecaoPublico'
import SecaoInscricao from './components/secoes/SecaoInscricao'
import SecaoLocal from './components/secoes/SecaoLocal'
import SecaoSobre from './components/secoes/SecaoSobre'
import SecaoPatrocinadores from './components/secoes/SecaoPatrocinadores'

import {
  EVENTO,
  TEMAS_PALCO,
  PALESTRANTES,
  PUBLICO_ALVO,
  SOBRE_TEXTO,
  NUMEROS_APRESENTA,
  PATROCINADORES,
  TEXTO_ALMOCO,
  TEXTO_LGPD,
} from './dados/evento'

/**
 * Registro das seções no Builder.io.
 *
 * ⚠️ ESTE ARQUIVO PRECISA SER IMPORTADO POR gatsby-browser.js E POR
 * gatsby-ssr.js. Se só o browser importar, o componente não existe na hora de
 * gerar o HTML estático e a seção sai vazia do build — a página parece certa no
 * navegador e chega vazia no Googlebot. Se só o SSR importar, o editor visual
 * não encontra os componentes e mostra a lista em branco.
 *
 * Todo `defaultValue` vem de src/dados/evento.js, que é a transcrição do
 * briefing aprovado. Assim quem abre o editor encontra a copy correta já no
 * lugar, em vez de campos vazios que alguém teria que preencher de novo.
 */

const NOME_MENU = 'Rota da Eficiência'

Builder.registerComponent(SecaoHero, {
  name: 'Dobra 1 — Hero',
  image: 'https://tabler-icons.io/static/tabler-icons/icons-png/layout-navbar.png',
  inputs: [
    { name: 'titulo', type: 'string', defaultValue: EVENTO.nome },
    {
      name: 'chamada',
      type: 'string',
      defaultValue: EVENTO.heroChamada,
      helperText:
        'Fecho do hero, em maiúsculas, depois do botão — a última coisa lida antes de continuar rolando a página. Vazio remove a linha.',
    },
    { name: 'tagline', type: 'string', defaultValue: EVENTO.tagline },
    {
      name: 'taglineDestaque',
      type: 'string',
      defaultValue: EVENTO.taglineDestaque,
      helperText:
        'Trecho da tagline que sai em negrito. Precisa ser um pedaço exato dela; se não bater, a frase sai sem negrito. Vazio desliga o destaque.',
    },
    { name: 'dataLegivel', type: 'string', defaultValue: EVENTO.dataLegivel },
    { name: 'cidade', type: 'string', defaultValue: EVENTO.cidade },
    { name: 'horario', type: 'string', defaultValue: EVENTO.horario },
    {
      name: 'dataISO',
      type: 'string',
      defaultValue: EVENTO.dataISO,
      helperText:
        'Alvo do contador, em ISO com fuso. Ex.: 2026-09-22T08:00:00-03:00. Sem o -03:00 o contador erra por 3 horas.',
    },
    { name: 'textoCta', type: 'string', defaultValue: 'Garantir minha presença' },
    {
      name: 'mascote',
      type: 'file',
      allowedFileTypes: ['png', 'webp'],
      defaultValue: EVENTO.heroMascote,
      helperText:
        'Nauta (o astronauta) no canto da cena. PNG com fundo transparente, ~800px de altura. Já vem preenchido. Vazio deixa a cena com estrada e estrelas — não quebra nada. Só aparece a partir de 1024px de largura.',
    },
    {
      name: 'fundo',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: EVENTO.heroFundo,
      helperText:
        'Foto de fundo do hero, com véu escuro por cima — é o padrão e já vem preenchida (Blumenau). Esvaziar troca a foto pela cena ilustrada da identidade, com a silhueta do casario no horizonte: funciona, mas é um visual que nunca foi ao ar.',
    },
  ],
})

Builder.registerComponent(SecaoPalco, {
  name: 'Dobra 2 — No palco',
  inputs: [
    {
      name: 'chamada',
      type: 'string',
      defaultValue: 'Conteúdo, tecnologia e eficiência para elevar o nível da gestão imobiliária',
    },
    { name: 'subtitulo', type: 'string', defaultValue: 'O que vai estar no palco do Rota da Eficiência' },
    {
      name: 'temas',
      type: 'list',
      defaultValue: TEMAS_PALCO,
      subFields: [
        { name: 'titulo', type: 'string' },
        { name: 'texto', type: 'longText' },
        {
          name: 'imagem',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
          helperText: 'Foto de fundo do tile (com véu escuro por cima). Pensada para os dois tiles largos; vazio deixa o tile só com o ícone.',
        },
      ],
    },
    /* Sem `textoCta`: a 2ª dobra não tem mais botão no fim (decisão de 08/08).
       O CTA daqui repetia o do cabeçalho e o da dobra de inscrição, e agora
       apareceria imediatamente depois do scroll-jacking horizontal — no exato
       momento em que a página volta a rolar normalmente, o que fazia o botão
       parecer o fim da seção em vez de um convite. */
  ],
})

Builder.registerComponent(SecaoPalestrantes, {
  name: 'Dobra 3 — Palestrantes',
  inputs: [
    { name: 'chamada', type: 'string', defaultValue: 'Palestrantes Confirmados' },
    { name: 'subtitulo', type: 'string', defaultValue: 'Em breve, programação completa' },
    {
      name: 'palestrantes',
      type: 'list',
      defaultValue: PALESTRANTES,
      subFields: [
        { name: 'nome', type: 'string' },
        { name: 'cargo', type: 'string' },
        { name: 'palestra', type: 'string' },
        { name: 'descricao', type: 'longText' },
        {
          name: 'foto',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
          helperText: 'Vazio mostra as iniciais do nome. Recortada em círculo — enviar imagem quadrada.',
        },
      ],
    },
    { name: 'textoCta', type: 'string', defaultValue: 'Quero estar presente' },
  ],
})

Builder.registerComponent(SecaoPublico, {
  name: 'Dobra 4 — Para quem é',
  inputs: [
    {
      name: 'chamada',
      type: 'string',
      defaultValue: 'Integração entre pessoas, processos, dados e gestão',
    },
    { name: 'subtitulo', type: 'string', defaultValue: 'O Rota da Eficiência Apresenta.me faz sentido para:' },
    {
      name: 'perfis',
      type: 'list',
      defaultValue: PUBLICO_ALVO,
      subFields: [
        { name: 'titulo', type: 'string' },
        { name: 'texto', type: 'longText' },
      ],
    },
    { name: 'textoCta', type: 'string', defaultValue: 'Garantir ingresso' },
  ],
})

Builder.registerComponent(SecaoInscricao, {
  name: 'Dobra 5 — Inscrição',
  inputs: [
    { name: 'chamada', type: 'string', defaultValue: 'Garanta seu ingresso gratuito agora mesmo!' },
    {
      name: 'subtitulo',
      type: 'string',
      defaultValue: 'Preencha os campos abaixo e garanta sua vaga antecipada ao evento.',
    },
    { name: 'textoAlmoco', type: 'longText', defaultValue: TEXTO_ALMOCO },
    {
      name: 'textoLgpd',
      type: 'longText',
      defaultValue: TEXTO_LGPD,
      helperText:
        'Ao alterar este texto, incrementar VERSAO_LGPD em src/dados/evento.js — a versão é gravada com cada inscrição e é o que demonstra a que a pessoa consentiu.',
    },
    { name: 'textoCta', type: 'string', defaultValue: 'Garantir minha presença' },
  ],
  /* Os campos do formulário NÃO são editáveis no Builder: cada um tem coluna
     própria na tabela `inscricoes` e validação no servidor. Adicionar campo pelo
     editor geraria dado que o backend descarta em silêncio. */
})

Builder.registerComponent(SecaoLocal, {
  name: 'Dobra 6 — Localização',
  inputs: [
    { name: 'chamada', type: 'string', defaultValue: 'Nos vemos em Blumenau!' },
    {
      name: 'texto',
      type: 'longText',
      defaultValue: `Para quem garantir o ingresso, o encontro acontece no dia ${EVENTO.dataLegivel}, das 8h às 19h, no ${EVENTO.local}, com estacionamento próprio.`,
    },
    {
      name: 'endereco',
      type: 'string',
      defaultValue: EVENTO.endereco,
      helperText: 'Alimenta o mapa incorporado e o link do Google Maps.',
    },
  ],
})

Builder.registerComponent(SecaoSobre, {
  name: 'Dobra 7 — Sobre a Apresenta.me',
  inputs: [
    { name: 'chamada', type: 'string', defaultValue: 'Evento realizado pela Apresenta.me' },
    { name: 'texto', type: 'longText', defaultValue: SOBRE_TEXTO },
    {
      name: 'numeros',
      type: 'list',
      defaultValue: NUMEROS_APRESENTA,
      subFields: [
        { name: 'valor', type: 'string' },
        { name: 'rotulo', type: 'string' },
      ],
    },
    {
      name: 'imagem',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/img/equipe-apresentame-web.jpg',
      helperText: 'Fundo de foto da seção inteira, com véu escuro por cima. Vazio cai no fundo sólido padrão.',
    },
    { name: 'textoCta', type: 'string', defaultValue: 'Conheça a Apresenta.me' },
    { name: 'urlCta', type: 'url', defaultValue: EVENTO.siteInstitucional },
  ],
})

Builder.registerComponent(SecaoPatrocinadores, {
  name: 'Dobra 8 — Patrocinadores',
  inputs: [
    { name: 'chamada', type: 'string', defaultValue: 'Patrocinadores' },
    {
      name: 'cotas',
      type: 'list',
      defaultValue: PATROCINADORES,
      subFields: [
        {
          name: 'cota',
          type: 'string',
          enum: ['Ouro', 'Prata', 'Bronze', 'Apoio'],
          helperText: 'Define o tamanho do bloco. Ouro é o maior, Apoio o menor.',
        },
        {
          name: 'empresas',
          type: 'list',
          subFields: [
            { name: 'nome', type: 'string' },
            { name: 'logo', type: 'file', allowedFileTypes: ['svg', 'png', 'webp'] },
          ],
        },
      ],
    },
  ],
})

/* Agrupa as 8 dobras num menu próprio do editor. Sem isto elas ficam soltas na
   lista geral do Builder, misturadas com os blocos nativos. */
Builder.register('insertMenu', {
  name: NOME_MENU,
  items: [
    { name: 'Dobra 1 — Hero' },
    { name: 'Dobra 2 — No palco' },
    { name: 'Dobra 3 — Palestrantes' },
    { name: 'Dobra 4 — Para quem é' },
    { name: 'Dobra 5 — Inscrição' },
    { name: 'Dobra 6 — Localização' },
    { name: 'Dobra 7 — Sobre a Apresenta.me' },
    { name: 'Dobra 8 — Patrocinadores' },
  ],
})
